import { doc, getDoc } from 'firebase/firestore';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Failure from '../../../core/Failure';
import { IPlan } from '@leedpulse-monorepo/interfaces';

async function getPlanById(planId: string): Promise<IPlan | null> {
  try {
    const db = firestore;

    const planDocRef = await getDoc(doc(db, FirestoreCollections.plans, planId));

    if (!planDocRef.exists()) {
      return null;
    }

    const plan = planDocRef.data() as IPlan;

    return plan;
  } catch (e) {
    console.error('error: ', e);
    throw new GetPlanByIdFailure();
  }
}

export class GetPlanByIdFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getPlanById;
